module.exports = __webpack_public_path__ + "img/ico-staging-default.afea0857.svg";